import { render } from "./ExamPromoBadge.vue?vue&type=template&id=479c4052&scoped=true"
import script from "./ExamPromoBadge.vue?vue&type=script&lang=js"
export * from "./ExamPromoBadge.vue?vue&type=script&lang=js"

import "./ExamPromoBadge.vue?vue&type=style&index=0&id=479c4052&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479c4052"]])

export default __exports__